import classStyle from './Order.module.scss';
import logo from '@src/assets/logo.png';
import logo_en from '@src/assets/logo_en.png';
// import usdtLogo from '@src/assets/usdtLogo.png';
import appLogo from '@src/assets/appLogo.png';
import scan from '@src/assets/scan.png';
import info3 from '@src/assets/info3.png';
import info4 from '@src/assets/info4.png';
import copy from '@src/assets/copy.png';
import iconDownload from '@src/assets/iconDownload.png';
import { useEffect, useState, useContext, useRef } from 'react';
import classNames from 'classnames';
import { useWindowDimensions } from '@src/hooks';
import copyTo from 'copy-to-clipboard';
import Services from '@src/api/services';
import router from '@src/routes/router';
import { downloadUrl } from '@src/baseUrl';
import moment from 'moment';
import { isAndroid } from '@src/unit';
import { QRCode } from 'react-qrcode-logo';
import { ToastContext } from '@src/context';
import queryString, { parse } from 'query-string';
import closeIcon from '@src/assets/close.png';
import { useTranslation } from 'react-i18next';
import { canUseLanguages } from '@src/i18n';

import { Trans } from 'react-i18next';

const maxWidth = 1200;
// 已完成支付彈窗顯示後，自動轉導至商戶跳轉地址的秒數
const autoRedirectSeconds = 3;

export default function Order(props) {
    const { t, i18n } = useTranslation();
    const toastContext = useContext(ToastContext);
    const { width } = useWindowDimensions();
    const [isLoading, setIsLoading] = useState(true);
    const [apiData, setApiData] = useState({});
    const [chainIndex, setChainIndex] = useState(0);
    const [chainInfoList, setChainInfoList] = useState([]);
    const [showAppLink, setShowAppLink] = useState(isAndroid);
    const [list, setList] = useState({
        validTime: {
            key: 'validTime',
            value: '',
            showCopy: false,
            show: true,
        },
        apiOrderId: {
            key: 'apiOrderId',
            value: '',
            showCopy: true,
            show: true,
        },
        amount: {
            key: 'amount',
            value: '',
            showCopy: false,
            show: true,
        },
        addressItem: {
            key: 'address',
            value: '',
            showCopy: true,
            show: false,
        },
    });
    // redirectUrl 為商戶發起訂單時帶的跳轉地址，非必填
    const { newVersion, coinType, coinId, redirectUrl } = apiData;
    const isMobileType = width <= 768;
    const changeSecondsToHours = (value) => {
        const time = moment.duration(value, 'seconds');
        // 小時用距離時間ex 100小時
        let hours = parseInt(time.asHours());

        if (hours < 10) {
            hours = `0${hours}`;
        }

        const minutes = time.minutes();
        const seconds = time.seconds();
        const mmss = moment({ m: minutes, s: seconds }).format('mm:ss');

        return `${hours}:${mmss}`;
    };
    const { token, cashierType } = router.getQuery();
    const [isOrderFinished, setIsOrderFinished] = useState(false);
    const isOrderFinishedRef = useRef(false);
    const redirectTimerRef = useRef(null);
    // 有跳轉地址時才顯示返回按鈕
    const showBack = !!redirectUrl;
    // 已完成支付且有跳轉地址，才跳出自動轉導彈窗
    const showRedirectModal = isOrderFinished === true && showBack;
    const goRedirect = () => {
        // 轉導至商戶平台，使用 replace 避免使用者按上一頁又回到收銀台
        window.location.replace(redirectUrl);
    };

    useEffect(() => {
        let interval;

        if (!token) {
            toastContext.setToast(t('order error'), 1.5 * 1000 * 100);

            return;
        }

        const handleSetData = (data) => {
            const { apiOrderId, amount, validTime, thirdlyChargeChainInfoList } = data;
            let validTimeCount = validTime;
            list.apiOrderId.value = apiOrderId;
            list.amount.value = trimEndZero(amount);
            list.validTime.value = changeSecondsToHours(validTimeCount);

            setApiData(data);
            setList({ ...list });
            setChainInfoList(thirdlyChargeChainInfoList);
            setIsLoading(false);

            // 先確認訂單一次
            checkOrderFinished(apiOrderId);
            interval = setInterval(() => {
                validTimeCount--;

                if (validTimeCount >= 0 && isOrderFinishedRef.current === false) {
                    list.validTime.value = changeSecondsToHours(validTimeCount);
                    setList({ ...list });
                } else {
                    list.validTime.value = '-- : -- : --';
                    setList({ ...list });
                    clearInterval(interval);
                }

                /// 檢查訂單是否結束
                if (validTimeCount % 10 === 0) {
                    checkOrderFinished(apiOrderId);
                }
            }, 1000);
        };

        // const test = () => {
        //     const data = {
        //         data: {
        //             apiOrderId: 'cbdd20240507f0xB7N5v1v4oea',
        //             coinType: 'USDC',
        //             coinId: 1,
        //             amount: '0.100',
        //             merchantCode: '1234567',
        //             thirdlyChargeChainInfoList: [
        //                 {
        //                     chainName: 'TRC20',
        //                     chainId: 2,
        //                     qrcodeContent: 'TPb52PcdLQT1QdbKgWY6bFdfRzuk8ArYkR',
        //                 },
        //                 {
        //                     chainName: 'ERC20',
        //                     chainId: 1,
        //                     qrcodeContent: '0x29c0a641dc48ebc12e3466c0af2066129ff60088',
        //                 },
        //                 {
        //                     chainName: 'BEP20',
        //                     chainId: 17,
        //                     qrcodeContent: '0x29c0a641dc48ebc12e3466c0af2066129ff60088',
        //                 },
        //             ],
        //             validTime: 1724,
        //             newVersion: true,
        //         },
        //         msg: 'success',
        //         code: 0,
        //         success: true,
        //     };

        //     handleSetData(data.data);
        // };
        // test();

        Services.getCharge({ token })
            .then((res) => {
                if (res.data.success) {
                    handleSetData(res.data.data);
                } else {
                    if (res.data.msg) {
                        // toastContext.setToast(res.data.msg, 1.5 * 1000 * 100);
                        toastContext.setToast(t('order error'), 1.5 * 1000 * 100);
                    } else {
                        toastContext.setToast(t('order error'), 1.5 * 1000 * 100);
                    }
                }
            })
            .catch((err) => {
                console.log('kailog', err);
                toastContext.setToast(t('order error'), 1.5 * 1000 * 100);
            });

        const checkOrderFinished = (apiOrderId) => {
            Services.chargeFinished(apiOrderId)
                .then((res) => {
                    console.log(JSON.stringify(res));
                    if (res.data.data === true) {
                        setIsOrderFinished(true);
                        isOrderFinishedRef.current = true;
                    }
                })
                .catch((err) => {
                    console.log('checkOrderFinshed error', err);
                });
        };

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 已完成支付且有跳轉地址時，倒數後自動轉導回商戶平台
    useEffect(() => {
        if (!showRedirectModal) {
            return;
        }

        redirectTimerRef.current = setTimeout(() => {
            window.location.replace(redirectUrl);
        }, autoRedirectSeconds * 1000);

        return () => {
            if (redirectTimerRef.current) {
                clearTimeout(redirectTimerRef.current);
                redirectTimerRef.current = null;
            }
        };
    }, [showRedirectModal, redirectUrl]);

    if (isLoading) {
        return <div className={classStyle.loading}></div>;
    }

    // 目前選的協議
    const chainInfo = chainInfoList[chainIndex];
    list.addressItem = {
        ...list.addressItem,
        value: chainInfo?.qrcodeContent,
        show: newVersion,
    };

    const openLink = () => {
        var ans = window.confirm(t('checkOpenApp'));
        if (ans) {
            const query = queryString.stringify({
                key: 'wallet',
                address: chainInfo?.qrcodeContent,
                coinId: coinId,
                coinChainId: chainInfo.chainId,
            });
            // 須加一個 open 路徑, 否則只會開到根目錄
            let bastUrl = 'ubitrp://open/open';

            const url = `${bastUrl}?${query}`;
            const myWin = window.open(url, '_blank');

            if (!myWin) {
                toastContext.setToast(t('openError'), 1500);
            }
        }
    };
    const openDownloadPage = () => {
        const myWin = window.open(downloadUrl, '_blank');

        if (!myWin) {
            toastContext.setToast(t('openError'), 1500);
        }
    };

    const isCn = i18n.language === 'zh';
    return (
        <div className={classStyle.container}>
            <div className={classStyle.page}>
                <div className={classStyle.header}>
                    {/* 左欄，有跳轉地址才顯示返回按鈕，無論如何都要保留佔位讓 logo 置中 */}
                    <div className={classStyle.headerSide}>
                        {showBack && (
                            <div className={classStyle.backButton} onClick={goRedirect}>
                                <BackIcon />
                                <span className={classStyle.backText}>{t('back')}</span>
                            </div>
                        )}
                    </div>
                    {/* 中欄，logo 置中 */}
                    <div className={classStyle.headerCenter}>
                        {cashierType != 2 && (
                            <img
                                src={isCn ? logo : logo_en}
                                className={isCn ? classStyle.logo : classStyle.logoEn}
                                alt=""
                            />
                        )}
                    </div>
                    {/* 右欄，語系切換 */}
                    <div className={classNames(classStyle.headerSide, classStyle.headerSideEnd)}>
                        <select
                            className={classStyle.select}
                            value={i18n.language}
                            onChange={(e) => {
                                i18n.changeLanguage(e.target.value);
                                localStorage.setItem('i18nextLng', e.target.value);
                            }}
                        >
                            {canUseLanguages.map((item) => {
                                return (
                                    <option key={item} value={item} className={classStyle.option}>
                                        {t(item)}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div className={classStyle.main}>
                    <div className={classStyle.from}>
                        <div className={classStyle.formTitle}>{t('order information')}</div>
                        <div className={classStyle.list}>
                            {Object.values(list).map((item) => {
                                if (item.show) {
                                    return (
                                        <FromItem
                                            key={item.key}
                                            item={item}
                                            coinType={coinType}
                                            isMobileType={isMobileType}
                                        />
                                    );
                                } else {
                                    return undefined;
                                }
                            })}
                        </div>
                    </div>
                    {isOrderFinished === true && <OrderFinshed />}
                    <QRCardView
                        setChainIndex={setChainIndex}
                        width={width}
                        isMobileType={isMobileType}
                        chainIndex={chainIndex}
                        chainInfo={chainInfo}
                        chainInfoList={chainInfoList}
                        coinType={coinType}
                        cashierType={cashierType}
                    />
                    {i18n.language === 'zh' && cashierType != 2 && (
                        <UseList
                            width={width}
                            isMobileType={isMobileType}
                            merchantCode={apiData.merchantCode}
                        />
                    )}
                </div>
            </div>
            {showAppLink && cashierType != 2 && (
                <div className={classStyle.openLinkBar}>
                    <div className={classStyle.linkTextCol}>
                        <div className={classStyle.linkText}>{t('ubitInstall')}</div>
                        <div className={classStyle.linkText2}>{t('ubitInstall2')}</div>
                    </div>

                    <div className={classStyle.linkButton} onClick={openDownloadPage}>
                        <img src={iconDownload} className={classStyle.downloadIcon} alt="" />
                        {t('ubitDownload')}
                    </div>

                    <div className={classStyle.linkButton2} onClick={openLink}>
                        {t('ubitOpen')}
                    </div>
                    <img
                        src={closeIcon}
                        className={classStyle.linkClose}
                        alt=""
                        onClick={() => {
                            setShowAppLink(false);
                        }}
                    />
                </div>
            )}
            {showRedirectModal && <RedirectModal />}
        </div>
    );
}

// 返回按鈕的圓框左箭頭，阿拉伯文為 RTL，箭頭方向由樣式翻轉
const BackIcon = () => {
    return (
        <svg className={classStyle.backIcon} viewBox="0 0 32 32" fill="none" aria-hidden="true">
            <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2" />
            <path
                d="M18 10.5 12.5 16 18 21.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M12.5 16H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
};

// 已完成支付的成功勾勾
const CheckIcon = () => {
    return (
        <svg className={classStyle.modalIcon} viewBox="0 0 64 64" fill="none" aria-hidden="true">
            <circle cx="32" cy="32" r="29" stroke="currentColor" strokeWidth="2.5" />
            <path
                d="M20 32.5 28.5 41 44 25.5"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

// 已完成支付，即將自動轉導回商戶平台的提示彈窗
const RedirectModal = () => {
    const { t } = useTranslation();

    return (
        <div className={classStyle.modalMask}>
            <div className={classStyle.modalCard}>
                <CheckIcon />
                <div className={classStyle.modalText}>{t('paymentCompletedRedirect')}</div>
            </div>
        </div>
    );
};

// 去尾零
const trimEndZero = (ori) => {
    var ret = [];
    var isFloat = ori.indexOf('.') > -1;
    if (isFloat) {
        var isAllZero = parseInt(ori.split('.')[1]) == 0;
        if (isAllZero) return ori.split('.')[0];

        var rOri = [...ori].reverse();
        var hitNotZero = false;
        for (var i = 0; i < rOri.length; i++) {
            if (rOri[i] !== '0') hitNotZero = true;
            if (hitNotZero) ret[i] = rOri[i];
        }
        return ret.reverse().join('');
    } else return ori;
};

// 如果地址过长无法显示完整， 则显示前15  后11位。 中间用…代替。
const getAddressValue = (addressValue) => {
    const address1 = addressValue.substring(0, 15);
    const address2 = addressValue.substring(addressValue.length - 11, addressValue.length);

    return `${address1}...${address2}`;
};

const FromItem = ({ item, coinType, isMobileType }) => {
    const { t } = useTranslation();
    const toastContext = useContext(ToastContext);
    const { key, value, showCopy } = item;
    const showCoinType = key === 'amount' && value !== '';
    let showValueText = value;

    if (isMobileType && key === 'address') {
        showValueText = getAddressValue(value);
    }

    return (
        <div className={classStyle.item}>
            <div className={classStyle.itemTitle}>{t(key)}</div>
            <div className={showCopy ? classStyle.itemValueMin : classStyle.itemValue}>
                {showValueText}
            </div>
            {showCopy && value !== '' && (
                <img
                    className={classStyle.copy}
                    src={copy}
                    alt=""
                    onClick={() => {
                        copyTo(value);
                        toastContext.setToast(t('copySuccess'), 1500);
                    }}
                />
            )}
            {showCoinType && <div className={classStyle.itemAmount}>{coinType}</div>}
        </div>
    );
};
const QRCardView = ({
    chainIndex,
    setChainIndex,
    width,
    isMobileType,
    chainInfo,
    chainInfoList,
    coinType,
    cashierType,
}) => {
    const { t } = useTranslation();
    const size = isMobileType ? (width / 750) * 250 : (width / maxWidth) * 250;
    const renderQrButton = (item, index) => {
        const isActive = index === chainIndex;
        const text = `${t('tronAssets')}${item.chainName}`;

        return (
            <div
                key={index}
                className={classNames(classStyle.button, isActive && classStyle.isActive)}
                onClick={() => setChainIndex(index)}
            >
                {text}
            </div>
        );
    };
    const qrTexts = [t('qrInfo1'), t('qrInfo2'), t('qrInfo3')];

    return (
        <div className={classStyle.qrCardView}>
            {true && <div className={classStyle.buttons}>{chainInfoList.map(renderQrButton)}</div>}
            {cashierType != 2 ? (
                <div className={classStyle.qrCodeTitle}>
                    <span>{t('qrTitle')}</span>
                    <span className={classStyle.qrCodeTitleHL}>{t('qrTitle2')}</span>
                </div>
            ) : (
                <div className={classStyle.qrCodeTitle}>
                    <span>{t('qrTitle0')}</span>
                </div>
            )}

            <div className={classStyle.qrCardInfo}>
                <QRCode
                    value={chainInfo?.qrcodeContent}
                    size={size}
                    quietZone={10}
                    ecLevel="M"
                    qrStyle="dots"
                    // logoImage={usdtLogo}
                />
                <div className={classStyle.qrTexts}>
                    <div>{t('attention')}</div>
                    {qrTexts.map((item, index) => {
                        const num = `${index + 1}.`;

                        return (
                            <div key={index} className={classStyle.qrTextItem}>
                                <div className={classStyle.qrTextNum}>{num}</div>
                                <div className={classStyle.qrTextContent}>
                                    <Trans
                                        i18nKey={item}
                                        values={{ coinType: coinType }}
                                        components={{
                                            strong: (
                                                <span
                                                    style={{
                                                        color: '#D32F2F',
                                                        fontWeight: 600,
                                                        fontSize: '2.6rem',
                                                    }}
                                                />
                                            ),
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

const UseList = ({ width, isMobileType, merchantCode }) => {
    const list = [
        {
            title: '① 打开UBIT应用。',
            text: '(可点击图标或手机扫码安装，下载UBIT 应用； 并完成注册UBIT账号。)',
            img: appLogo,
            imgClass: classStyle.appLogo,
            showQrCode: true,
        },
        {
            title: '② 打开应用',
            text: '',
            img: undefined,
            showQrCode: false,
        },
        {
            title: `③ 使用应用内的扫码功能`,
            title2: `， 扫订单二维码； 获得汇款信息。`,
            text: '',
            img: info3,
            imgClass: classStyle.infoImg,
            showQrCode: false,
        },
        {
            title: '④ 在界面内，输入验证信息，进行汇款。',
            text: '（如余额不足，可通过应用内的【去交易-买币】 或【资产-充币】，补充余额）',
            img: info4,
            imgClass: classStyle.infoImg,
            showQrCode: false,
        },
        {
            title: '⑤ 完成充值。 可稍后查询账户资金,进行确认。',
            text: '',
            img: undefined,
            showQrCode: false,
        },
    ];

    const size = isMobileType ? (width / 750) * 160 : (width / maxWidth) * 160;

    return (
        <div className={classStyle.useList}>
            <div className={classStyle.useListTitle}>怎么使用优币钱包操作</div>
            {list.map((item, index) => {
                const { title, title2, text, img, imgClass, showQrCode } = item;

                return (
                    <div key={index} className={classStyle.useListItem}>
                        <div className={classStyle.useItemTitleBar}>
                            <span className={classStyle.useItemTitle}>{title}</span>
                            {title2 && (
                                <>
                                    <img className={classStyle.scan} src={scan} alt="" />
                                    <span className={classStyle.useItemTitle}>{title2}</span>
                                </>
                            )}
                        </div>
                        <div className={classStyle.useItemText}>{text}</div>
                        <div className={classStyle.useItemInfo}>
                            {img && (
                                <img
                                    className={imgClass}
                                    src={img}
                                    alt=""
                                    onClick={() => {
                                        window.location.href = downloadUrl;
                                    }}
                                />
                            )}
                            {showQrCode && (
                                <>
                                    <div className={classStyle.useItemInfoText}>或</div>
                                    {showQrCode && (
                                        <QRCode
                                            value={`${downloadUrl}?merchantCode=${merchantCode}`}
                                            size={size}
                                            quietZone={5}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const OrderFinshed = () => {
    const { t } = useTranslation();
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '3.0rem',
            }}
        >
            <span
                style={{
                    color: '#D32F2F',
                    fontWeight: 600,
                    fontSize: '5.0rem',
                    textAlign: 'center',
                }}
            >
                {t('orderFinshed')}
            </span>
        </div>
    );
};
